export const APP_URL = process.env.APP_URL;
export const NEXT_BUILD_ID = process.env.NEXT_BUILD_ID;
export const IS_PRODUCTION_BUILD = process.env.NEXT_PHASE === 'phase-production-build';
export const IS_DEBUG = process.env.NEXT_PUBLIC_APP_DEBUG === 'true';
export const NEXT_PUBLIC_APP_VERSION = process.env.NEXT_PUBLIC_APP_VERSION || '0.0.0';
export const NEXT_PUBLIC_BUGSNAG_API_KEY = process.env.NEXT_PUBLIC_BUGSNAG_API_KEY;
export const NEXT_PUBLIC_EMAIL_SERVICE_URL = process.env.NEXT_PUBLIC_EMAIL_SERVICE_URL;
export const NEXT_PUBLIC_GRAPHQL_ENDPOINT = process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT || 'http://localhost:4000';
export const NEXT_PUBLIC_PARTNER_URL = process.env.NEXT_PUBLIC_PARTNER_URL;
export const NEXT_PUBLIC_WEBSITE_BASE_URL = process.env.NEXT_PUBLIC_WEBSITE_BASE_URL;